import { useState } from "react";

import { getCodeBySystem } from "@medplum/core";
import { Observation } from "@medplum/fhirtypes";

import { Anchor, Table, Tooltip } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import EditLaborRow from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/EditLaborRow";
import EditMilestoneRow from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/EditMilestoneRow";
import { LOINCCodes } from "@/fhir/enums/loinc";
import { Systems } from "@/fhir/enums/systems";

export enum TimeCellVariants {
  Default = "burgundy.9",
  Gray = "gray.5",
}

interface TimeCellProps extends React.ComponentProps<typeof Table.Td> {
  time: string | undefined;
  rowSpan: number;
  observation?: Observation;
  isViewOnly?: boolean;
  variant?: string;
}

export default function TimeCell({
  time,
  rowSpan,
  isViewOnly,
  variant = TimeCellVariants.Default,
  ...props
}: TimeCellProps) {
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const observation = props.observation;

  const handleClick = () => {
    setShowEditDrawer(true);
  };

  const handleClose = () => {
    setShowEditDrawer(false);
  };

  // Check if this is a milestone observation using getCodeBySystem
  const loincCode = observation?.code
    ? getCodeBySystem(observation.code, Systems.LOINC)
    : undefined;
  const isMilestone = loincCode === LOINCCodes.LaborStage;

  return (
    <Table.Td fw="bold" miw={100} c={variant} ta="center" rowSpan={rowSpan} {...props}>
      {isViewOnly ? (
        <TextWrapper>{time}</TextWrapper>
      ) : (
        <Tooltip label="Edit Row" aria-label="Edit Row">
          <Anchor href={`#${time}`} onClick={handleClick}>
            {time}
          </Anchor>
        </Tooltip>
      )}
      {showEditDrawer &&
        observation &&
        (isMilestone ? (
          <EditMilestoneRow onClose={handleClose} observation={observation} />
        ) : (
          <EditLaborRow onClose={handleClose} observation={observation} />
        ))}
    </Table.Td>
  );
}
